<template>
  <LotteryBasePage>
    <PowerballXsAndOsBasePlaySlip />
  </LotteryBasePage>
</template>
